import request from 'tools/request'


const mapEmailLogField = (field) => {
    switch (field) {
        case 'date': return 'email_date';
        case 'from': return 'sender';
        case 'to': return 'recipient';
        case 'applicationId': return 'appId';
        case 'fileName': return 'filename';
        default: return field;
    }
}
export const getEmailLogs = (pagination = {}, filters = {}) => async (dispatch) => {
    const sortFieldName = mapEmailLogField(pagination?.orderBy?.field) ;

    const headers = {
        'X-Pagination-Limit': pagination.limit || 20,
        'X-Pagination-Num': pagination.page || 0,
        'X-Pagination-Sort': `${sortFieldName || 'createdAt'},${pagination?.orderBy?.order || 'desc'}`,
    }

    // Build query parameters from filters
    const params = {}
    if (filters.from) params.from = filters.from
    if (filters.to) params.to = filters.to
    if (filters.subject) params.subject = filters.subject
    if (filters.status) params.status = filters.status
    if (filters.applicationId) params.applicationId = filters.applicationId

    const res = await request('gmail/log', 'GET', null, true, headers, params)

    // Extract pagination info from headers
    const paginationInfo = {
        limit: parseInt(res.headers['x-pagination-limit']) || 20,
        totalRecords: parseInt(res.headers['x-pagination-total-records']) || 0,
        totalPages: parseInt(res.headers['x-pagination-total-pages']) || 0,
        currentPage: parseInt(res.headers['x-pagination-current-page-num']) || 0,
        nextPage: parseInt(res.headers['x-pagination-next-page-num']) || null,
        hasNextPage: res.headers['x-pagination-has-next-page'] === 'true'
    }

    return {
        data: res.response,
        pagination: paginationInfo
    }

}